import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useCustomToast } from 'design-system';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'api/v1/cms/restaurant-suppliers/branches';
export const getRelationBranchesEndpointIdentifier = endpoint;

type TData = { data: { id: number; name: string; isAssigned: boolean }[] };
type TError = AxiosError;
type TQueryKey = [string, { restaurantId: number; supplierId: number }];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetRelationBranchesApi(restaurantId: number, supplierId: number, options?: Options): ReturnType {
  const toast = useCustomToast();

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint, { params: { restaurantId, supplierId } });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([endpoint, { restaurantId, supplierId }], queryFn, options);
}
